import { useFieldArray } from 'react-hook-form';
import SchoolRecordInput from './SchoolRecordInput';

const ExploratoryTable = ({ register, control, isRead = false }) => {

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'exploratory',
    });


    return (
        <table className='table table-sm table-bordered text-center align-middle'>
            <thead>
                <tr>
                    <th width={"60px"}>
                        No
                    </th>
                    <th width={"100px"}>
                        Grade
                    </th>
                    <th width={"auto"}>
                        Title
                    </th>
                    {!isRead && <th width={"60px"}></th>}
                </tr>

            </thead>

            <tbody>
                {fields.map((field, index) => {
                    return (
                        <tr key={field.id}>
                            <td>
                                {index + 1}
                            </td>
                            <td>
                                <SchoolRecordInput register={register} name={`exploratory.${index}.grade`} isRead={isRead} />
                            </td>
                            <td>
                                <SchoolRecordInput register={register} name={`exploratory.${index}.title`} isRead={isRead} />
                            </td>
                            {!isRead &&
                                <td>
                                    <button type="button" className='btn btn-sm btn-outline-danger' onClick={() => remove(index)}>삭제</button>
                                </td>
                            }
                        </tr>
                    )
                })}

                {!isRead &&
                    <tr>
                        <td colSpan={4}>
                            <button
                                type="button"
                                className='btn btn-sm btn-outline-primary'
                                onClick={() => append({ grade: '', title: '' })}
                            >추가</button>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    )
}

export default ExploratoryTable